var scope_0 = require('C:/Users/user/Documents/GitHub/prelaunch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('C:/Users/user/Documents/GitHub/prelaunch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1dedd3e1ab3c92125da0ab636ca92ef7.js').default;
var scope_2 = require('C:/Users/user/Documents/GitHub/prelaunch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    